import React, { useMemo, useRef, useState } from "react";

// small utility (you already have a similar one)
const normalizeComment = (c) => {
  if (typeof c === "string") {
    return { id: Math.random().toString(36).slice(2), mechanic_observation: c, created_at: null, created_by: null };
  }
  const text = c?.observation ?? c?.description ?? c?.comment ?? c?.mechanic_observation ?? c?.title ?? "";
  return {
    id: c?.service_comments_id ?? c?.id ?? Math.random().toString(36).slice(2),
    mechanic_observation: text,
    created_at: c?.created_at || c?.updated_at || null,
    created_by: c?.user_name || c?.created_by || null,
  };
};

const formatDateLocal = (dateStr) => {
  try {
    if (!dateStr) return "";
    return new Date(dateStr).toLocaleString("pt-BR");
  } catch {
    return "";
  }
};

/**
 * Memoized comments box. Uses an *uncontrolled* <textarea> (ref)
 * so keystrokes don't cause React state updates/re-renders.
 */
export const OsComments = React.memo(function OsComments({
  serviceId,
  user,
  initialComments,
  postCommentApi, // (source, service_id, observation) => Promise
}) {
  const isMechanic = user?.role === "MECANICO";
  const [comments, setComments] = useState(() => (initialComments || []).map(normalizeComment));
  const [saving, setSaving] = useState(false);
  const inputRef = useRef(null);

  const handleAdd = async () => {
    const value = (inputRef.current?.value || "").trim();
    if (!value) return;

    try {
      setSaving(true);
      await postCommentApi(serviceId, value);

      // optimistic local append
      setComments((prev) => [
        {
          id: Math.random().toString(36).slice(2),
          text: value,
          created_at: new Date().toISOString(),
          created_by: user?.name || "Mecânico",
        },
        ...prev,
      ]);
      if (inputRef.current) inputRef.current.value = "";
    } finally {
      setSaving(false);
    }
  };

  return (
    <div>
      {isMechanic && (
        <div className="mb-4">
          <label htmlFor="osCommentBox" className="block text-sm font-medium text-gray-700 mb-2">
            Novo comentário
          </label>
          <textarea
            id="osCommentBox"
            rows={3}
            ref={inputRef}
            className="w-full rounded border-gray-300 focus:ring-blue-500 focus:border-blue-500"
            placeholder="Escreva um comentário para esta OS"
            // UNCONTROLLED: no value/onChange here
          />
          <div className="mt-3">
            <button
              type="button"
              onClick={handleAdd}
              disabled={saving}
              className={`px-4 py-2 rounded text-white ${
                saving ? "bg-blue-300" : "bg-blue-600 hover:bg-blue-700"
              }`}
            >
              {saving ? "Enviando..." : "Adicionar Comentário"}
            </button>
          </div>
        </div>
      )}

      {comments?.length ? (
        <ul className="space-y-3">
          {comments.map((c) => (
            <li key={c.id} className="bg-white border rounded p-3">
              <div className="flex items-center justify-between mb-1">
                <span className="text-sm text-gray-500">{c.created_by || "—"}</span>
                <span className="text-xs text-gray-400">{formatDateLocal(c.created_at)}</span>
              </div>
              <p className="text-gray-800 whitespace-pre-wrap">{c.mechanic_observation}</p>
            </li>
          ))}
        </ul>
      ) : (
        <p className="text-gray-500">Nenhum comentário registrado.</p>
      )}
    </div>
  );
});
